import ListData from '@/generated/classes/ListData';
import { ListItem as ListItemBase } from '@/generated/classes/ListData';
import { ListChoix as ListChoixBase } from '@/generated/classes/ListData';
import { ListConfig as ListConfigBase } from '@/generated/classes/ListData';
import { ColumnConfig as ColumnConfigBase } from '@/generated/classes/ListData';
import { ListFilter as ListFilterBase } from '@/generated/classes/ListData';
import { ColumnFilter as ColumnFilterBase } from '@/generated/classes/ListData';
export default class ListDataExtend extends ListData {
  constructor() {
    super();
  }
}
export class ListItem extends ListItemBase {
  constructor() {
    super();
  }
}
export class ListChoix extends ListChoixBase {
  constructor() {
    super();
  }
}
export class ListConfig extends ListConfigBase {
  constructor() {
    super();
  }
}
export class ColumnConfig extends ColumnConfigBase {
  constructor() {
    super();
  }
}
export class ListFilter extends ListFilterBase {
  constructor() {
    super();
  }
}
export class ColumnFilter extends ColumnFilterBase {
  constructor() {
    super();
  }
}
